import React from 'react'

const SettingsPerksIcon = (
  <>
    <path
      d="M17.75 6.37278H11.8212L9.857 0.258038C9.7925 0.0611634 9.58025 -0.0457098 9.38375 0.0187883C9.2705 0.0559133 9.18163 0.144788 9.1445 0.258038L7.17875 6.37278H1.25C1.043 6.37278 0.875 6.54078 0.875 6.74778C0.875 6.86403 0.928625 6.97353 1.0205 7.04441L5.75 10.7055L3.782 16.7569C3.71788 16.9538 3.82588 17.1653 4.02275 17.2294C4.13713 17.2665 4.262 17.2467 4.35913 17.1762L9.5 13.4415L14.6409 17.1762C14.8085 17.298 15.0429 17.2609 15.1647 17.0933C15.2352 16.9962 15.2551 16.8709 15.218 16.7569L13.25 10.7055L17.978 7.04441C18.1419 6.91766 18.1719 6.68216 18.0451 6.51828C17.9742 6.42678 17.8655 6.37316 17.75 6.37278Z"
      fill="url(#paint0_linear_2520_14849)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2520_14849"
        x1="9.49929"
        y1="8.39509e-07"
        x2="9.49929"
        y2="17.2479"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD36E" />
        <stop offset="1" stopColor="#F6B828" />
      </linearGradient>
    </defs>
  </>
)

export default SettingsPerksIcon
